import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppSettings } from 'src/app/services/AppSettings';
import { JobService } from 'src/app/services/job.service';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import Swal from "sweetalert2";
import { ApiService } from './../../services/api.service';
import { UtilService } from './../../services/util.service';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { FilterPipe } from '../../pipe/filter.pipe';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { NodataFoundComponent } from '../nodata-found/nodata-found.component';


@Component({
  selector: 'app-visitors',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    BsDropdownModule,
    InfiniteScrollModule,
    NgxPaginationModule,
    CommonSkeletonComponent,
FilterPipe
  ,
    NG_ICON_DIRECTIVES,
    NodataFoundComponent,
  ],
  templateUrl: './visitors.component.html',
  styleUrls: ['./visitors.component.scss']
})
export class VisitorsComponent implements OnInit, OnChanges {

  @Input('title') title: any = 'Visitors';
  visitorsData: Array<any> = [];
  @Input() inputData: string;
  @Input() suggestion: any;
  headerTitle: any = 'Visitors';
  showUI = false;
  apicalled: boolean = false;
  searchName: any;
  admin: Array<any> = [{ src: '1.jpg' }, { src: '2.jpg' }, { src: '3.jpg' }, { src: '4.jpg' }, { src: '5.jpg' },
  { src: '6.jpg' }, { src: '7.jpg' }, { src: '8.jpg' }, { src: '9.jpg' }];
  userData: any[];
  commonDatahide: any = {}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  @Input() maxMin: any = {};
  @Input() page: string;
  viewType: string = "MIN";
  url = AppSettings.photoUrl;
  loadAPIcall: boolean = false;
  id;
  userCardConfig: UserCardConfig[] = []
  @Input() widgetDesc: string;
  businessId: any;

  // Infinite scroll properties
  isLoading = false;
  stopScroll: boolean = false;
  previousSearchAfterKey: any = null;
  items: any[] = [];
  params = {
    limit: 10,
    businessId: null,
    searchAfterKey: null,
  };

  constructor(private auth: ApiService,
    private routes: ActivatedRoute,
    private a_route: ActivatedRoute,
    private util: UtilService,
    private router: Router,
    private modalService: BsModalService,
    private JobServicecolor: JobService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
    this.headerTitle = this.title;

    console.log('VisitorsComponent constructor: widgetData received =', this.widgetData);

    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
        console.log('VisitorsComponent constructor: Set inputData =', this.inputData);
      }
      if (this.widgetData.page) {
        this.page = this.widgetData.page;
        console.log('VisitorsComponent constructor: Set page =', this.page);
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
      if (this.widgetData.commonFunction) {
        this.commonFunction = this.widgetData.commonFunction;
        console.log('VisitorsComponent constructor: commonFunction received');
      }
    } else {
      console.log('VisitorsComponent constructor: No widgetData received!');
    }
  }

  route(item) {
    this.router.navigate(['personalProfile'], { queryParams: item });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    console.log('VisitorsComponent ngOnInit: inputData =', this.inputData, 'page =', this.page);

    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if (res.master && res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })
    let invite: UserCardConfig = new UserCardConfig("Invite", this.inviteFollower, this.canShow, true);
    invite.source = this;
    this.userCardConfig.push(invite);
    this.routes.queryParams.subscribe((res) => {
      this.id = res.id;
    });

    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }

    // Reset scroll state on initialization
    this.resetScrollState();
    this.getVisitors();
  }

  // Reset scroll state for new data loading
  resetScrollState() {
    this.items = [];
    this.visitorsData = [];
    this.previousSearchAfterKey = null;
    this.stopScroll = false;
    this.isLoading = false;
  }

  // for first and last name
  getInitialName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  // for first and last name
  getColorName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  getVisitors() {
    console.log('VisitorsComponent getVisitors: inputData =', this.inputData);
    this.loadAPIcall = true;
    if (this.inputData == "BUSINESS") {
      this.businessId = localStorage.getItem('businessId');
      console.log('VisitorsComponent getVisitors: businessId =', this.businessId);
      if (!this.businessId) {
        console.log('VisitorsComponent getVisitors: No businessId found, hiding widget');
        this.util.stopLoader();
        this.loadAPIcall = false;
        this.showUI = false;
        this.hide(true);
        return;
      }

      this.loadData();
    }
    else if (this.inputData == "COMMUNITY") {
      var datas = {
        "communityId": localStorage.getItem('communityId'),
        "userId": localStorage.getItem('userId'),
        "page": {
          "offSet": 0,
          "pageCount": 100
        }
      }

      this.auth.create("community/members/visited", datas).subscribe((res) => {
        this.loadAPIcall = false;
        this.util.stopLoader();
        this.showUI = false;
        if (res != null && res != undefined && res.data && res.data.visitorList && res.data.visitorList.length != 0) {
          this.visitorsData = [];
          let processedCount = 0;
          const totalToProcess = res.data.visitorList.length;

          res.data.visitorList.forEach(element => {
            if (element.userId != 'undefined' && element.userId != 'null' && element.userId != null && element.userId != '') {
              this.auth.query('user/connection/' + element.userId).subscribe(response => {
                processedCount++;
                
                if (element.status == 'REQUEST SEND') {
                  element.status = 'REQUEST_SENT'
                }
                this.showUI = true;
                response.status = element.status;
                this.visitorsData.push(response);
                
                // Check if all items have been processed
                if (processedCount === totalToProcess && this.visitorsData.length === 0) {
                  this.showUI = false;
                  this.hide(true);
                }
              }, error => {
                processedCount++;
                // Check if all items have been processed
                if (processedCount === totalToProcess && this.visitorsData.length === 0) {
                  this.showUI = false;
                  this.hide(true);
                }
              });
            } else {
              processedCount++;
              // Check if all items have been processed
              if (processedCount === totalToProcess && this.visitorsData.length === 0) {
                this.showUI = false;
                this.hide(true);
              }
            }
          });
        } else {
          this.hide(true);
        }
      }, err => {
        this.loadAPIcall = false;
        this.util.stopLoader();
        this.hide(true);
      });
    } else {
      console.log('VisitorsComponent getVisitors: inputData is not BUSINESS or COMMUNITY, value =', this.inputData);
      this.loadAPIcall = false;
      this.showUI = false;
      this.util.stopLoader();
    }
  }

  infiniteScrollTriggered() {
    if (!this.isLoading && !this.stopScroll && this.inputData === "BUSINESS") {
      console.log("Infinite scroll triggered, loading more data");
      this.loadData(this.previousSearchAfterKey);
    } else {
      console.log("Scroll ignored - isLoading:", this.isLoading, "stopScroll:", this.stopScroll);
    }
  }

  loadData(searchAfterKey: any = null): void {
    // Prevent multiple simultaneous API calls
    if (this.isLoading) {
      console.log("VisitorsComponent loadData: Already loading data, ignoring request");
      return;
    }

    this.isLoading = true;
    console.log("VisitorsComponent loadData: Loading data with searchAfterKey:", searchAfterKey);

    const businessId = localStorage.getItem('businessId');
    console.log("VisitorsComponent loadData: businessId =", businessId);
    if (!businessId) {
      console.error("VisitorsComponent loadData: No businessId found. Cannot make API request.");
      this.isLoading = false;
      this.loadAPIcall = false;
      return;
    }

    // Format search key properly for the API
    const formattedKey = searchAfterKey ? [searchAfterKey] : null;

    const apiUrl = `business/visitor`;
    const payload = {
      limit: 10,
      searchAfterKey: formattedKey,
      businessId: businessId
    };

    // Use startLoader only for initial load
    if (!searchAfterKey) {
      this.util.startLoader();
    }

    this.auth.create(apiUrl, payload).subscribe(
      (res) => {
        this.loadAPIcall = false;

        // Only stop loader for initial load
        if (!searchAfterKey) {
          this.util.stopLoader();
        }

        console.log("VisitorsComponent loadData: API Response:", res);

        if (res && res.data) {
          const { data } = res;
          
          // Process searchAfterKey
          let key = null;
          if (data.searchAfterKey) {
            key = Array.isArray(data.searchAfterKey) ? data.searchAfterKey[0] : data.searchAfterKey;
            console.log("Extracted searchAfterKey:", key);
          }

          // Process visitor data
          if (data.visitedList && data.visitedList.length > 0) {
            console.log('VisitorsComponent loadData: Found', data.visitedList.length, 'visitors, setting showUI = true');
            this.showUI = true;
            
            // For initial load, replace all data
            if (!searchAfterKey) {
              this.visitorsData = [...data.visitedList];
              this.items = [...data.visitedList];
            } else {
              // For subsequent loads, append data
              this.visitorsData = [...this.visitorsData, ...data.visitedList];
              this.items = [...this.items, ...data.visitedList];
            }
            
            console.log("Updated visitorsData length:", this.visitorsData.length);
            
            // Update pagination config if needed
            if (data.totalCount) {
              this.config.itemsPerPage = data.totalCount;
            }
            // Real total for the "+N" bubble after the avatar row (first page only).
            if (!searchAfterKey) {
              this.visitorTotal = Number(data.totalCount) || null;
            }

            // Update searchAfterKey for next page if different
            if (key && key !== this.previousSearchAfterKey) {
              this.previousSearchAfterKey = key;
              this.stopScroll = false;
            } else {
              console.log("No new key found or key is the same. Stopping scroll.");
              this.stopScroll = true;
            }
          } else {
            // No data in response
            console.log('VisitorsComponent loadData: No visitedList data in response');
            if (!searchAfterKey) {
              // Initial load with no data
              console.log('VisitorsComponent loadData: Initial load with no data, hiding widget');
              this.showUI = false;
              this.hide(true);
            } else {
              // No more data to load
              this.stopScroll = true;
            }
          }
        } else {
          // Invalid response
          console.log('VisitorsComponent loadData: Invalid response (no data property)');
          if (!searchAfterKey) {
            this.showUI = false;
            this.hide(true);
          }
          this.stopScroll = true;
        }
        
        this.isLoading = false;
      },
      (err) => {
        console.error("VisitorsComponent loadData: API Error:", err);
        this.loadAPIcall = false;
        this.isLoading = false;

        // Only stop loader for initial load
        if (!searchAfterKey) {
          console.log('VisitorsComponent loadData: Error on initial load, hiding widget');
          this.util.stopLoader();
          this.showUI = false;
          this.hide(true);
        }

        this.stopScroll = true;
      }
    );
  }

  storedPage: any;
  beingTyped: boolean = false
  // onSearch(event: any) {
  //   if (event.target.value != '') {
  //     this.config.currentPage = 1
  //     this.beingTyped = true
  //   } else if (event.target.value == '') {
  //     this.config.currentPage = this.storedPage
  //     this.beingTyped = false
  //   }
  // }

  onSearch(event: any) {
    const value = event.target.value;
    const searchValue = value.trim();
 
    this.searchName = value;
 
    if (searchValue !== '') {
      this.config.currentPage = 1;
      this.beingTyped = true;
    } else if (value.length > 0) {
      // Input contains only spaces
      this.config.currentPage = 1;
      this.beingTyped = true;
    } else {
      this.config.currentPage = this.storedPage;
      this.beingTyped = false;
    }
  }

  page1
  config = {
    itemsPerPage: 10,
    currentPage: 1
  }

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };

  pagecount(count) {
    this.config.currentPage = count
    this.storedPage = count
  }

  modalRef: BsModalRef;
  modelopen(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.backdropConfig);
  }

  onScrollDown() {
    this.infiniteScrollTriggered();
  }

  userprofile(data) {
    var userData: any = {}
    userData.userId = data
    this.router.navigate(['personalProfile'], { queryParams: userData })
  }
  
  canShow() { }

  selectedEntities: any = []
  checkedList: any = []

  onCheckboxChange(data, event) {
    if (event.target.checked) {
      this.selectedEntities.push(String(data.userId))
      this.checkedList.push(String(data.userId))
    } else {
      this.theChecker = false
      for (var i = 0; i < this.selectedEntities.length; i++) {
        if (this.selectedEntities[i] === String(data.userId)) {
          this.checkedList.splice(i, 1);
          this.selectedEntities.splice(i, 1);
          break;
        }
      }
    }
    // Auto-tick Select All once every visible (search-filtered) row is checked.
    data.checked = event.target.checked;
    const visible = new FilterPipe().transform(this.visitorsData, this.searchName);
    this.theChecker = visible.length > 0 && visible.every(ele => ele.checked);
  }

  dismiss() {
    this.modalRef.hide()
    this.selectedEntities = []
    this.checkedList = []
    setTimeout(() => {
      this.searchName = ''
      this.theChecker = false
      this.config.currentPage = 1
      this.visitorsData.forEach(ele => {
        ele.checked = false
      })
    }, 1000);
  }

  theChecker: any;

  /** Avatars in the row: 6 on the Business listing page (wider column), 5 elsewhere (Business detail page etc.). */
  get avatarLimit(): number {
    return this.router.url.startsWith('/landingPage/business') ? 6 : 5;
  }

  /** Business visitors: real `data.totalCount` (null until known). */
  visitorTotal: number | null = null;

  /** "+N" bubble: visitors beyond the avatars shown (same as Invite Your Connections). */
  get visitorMore(): number {
    if (!this.visitorTotal) { return 0; }
    return Math.max(0, this.visitorTotal - Math.min(this.visitorsData.length, this.avatarLimit));
  }

  checkAll(event) {
    // Select All must act on the current search results only — not the whole
    // list — so it never selects rows hidden by the search. Use the same
    // FilterPipe the modal list (and the Select All *ngIf) use, so "all" here
    // means exactly the visible/filtered records. Mirrors the connections modal.
    const visible = new FilterPipe().transform(this.visitorsData, this.searchName);
    if (event.target.checked == true) {
      visible.forEach(ele => {
        ele.checked = true
        if (!this.selectedEntities.includes(String(ele.userId))) {
          this.selectedEntities.push(String(ele.userId))
          this.checkedList.push(String(ele.userId))
        }
      })
    } else if (event.target.checked == false) {
      this.selectedEntities = []
      this.checkedList = []
      visible.forEach(ele => {
        ele.checked = false
      })
    }
  }

  closeModal() {
    this.modalRef.hide()
    this.selectedEntities = []
    this.checkedList = []
    setTimeout(() => {
      this.searchName = ''
      this.theChecker = false
      this.config.currentPage = 1
      this.visitorsData.forEach(ele => {
        ele.checked = false
      })
    }, 1000);
  }

  tempcheckedList: any = []

  inviteAll() {
    if (this.selectedEntities.length === 0) {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Please select users to invite',
        showConfirmButton: false,
        timer: 1500
      });
      return;
    }
    
    this.apicalled = true;
    
    if (this.inputData == 'BUSINESS') {
      var userIds = this.selectedEntities.join(',');
      var busId = localStorage.getItem('businessId');
      this.util.startLoader();
      
      this.auth.create("business/visitor/send/requests?businessId=" + busId + "&users=" + userIds + "&source=VISITOR", null).subscribe(res => {
        this.util.stopLoader();
        this.apicalled = false;
        
        if (res.code == '00000') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Invitation sent successfully',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            // Remove invited users from list
            this.selectedEntities.forEach(userId => {
              for (let i = 0; i < this.visitorsData.length; i++) {
                if (String(this.visitorsData[i].userId) === userId) {
                  this.visitorsData.splice(i, 1);
                  break;
                }
              }
            });

            if (this.visitorsData.length == 0) {
              this.showUI = false;
              this.hide(true);
            }
            
            this.modalRef.hide();
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Oops..',
            text: 'Something went wrong. Please try again later.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      }, err => {
        this.util.stopLoader();
        this.apicalled = false;
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Failed to send invitations. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        });
      });
    } else if (this.inputData == 'COMMUNITY') {
      var userIds = this.selectedEntities.join(',');
      
      var data: any = {};
      data.userId = userIds;
      data.entityId = localStorage.getItem('communityId');
      data.source = 'VISITOR';
      data.sentBy = localStorage.getItem('userId');
      
      this.util.startLoader();
      this.auth.create("community/send/invite", data).subscribe(res => {
        this.apicalled = false;
        this.util.stopLoader();
        
        if (res.code == '0000') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Invitation sent successfully',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.resetScrollState();
            this.getVisitors();
            this.modalRef.hide();
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Oops!',
            text: 'Something went wrong. Please, try again later',
            showConfirmButton: false,
            timer: 1500
          });
        }
      }, err => {
        this.apicalled = false;
        this.util.stopLoader();
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Failed to send invitations. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        });
      });
    }
  }

  inviteFollower(user) {
    if (!user || !user.userId) {
      return;
    }

    let data: any = {};
    data.userId = user.userId;
    
    if (this.inputData == "COMMUNITY") {
      data.entityId = localStorage.getItem('communityId');
      data.communityId = localStorage.getItem('communityId');
      data.sentBy = localStorage.getItem('userId');
      
      this.util.startLoader();
      this.auth.create('community/send/invite', data).subscribe(res => {
        this.util.stopLoader();
        
        if (res.code == "00000") {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Invite sent successfully',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            // Remove the invited user from the list
            for (let i = 0; i < this.visitorsData.length; i++) {
              if (this.visitorsData[i].userId === user.userId) {
                this.visitorsData.splice(i, 1);
                break;
              }
            }
            
            if (this.visitorsData.length === 0) {
              this.showUI = false;
              this.hide(true);
            }
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Oops..',
            text: 'Something went wrong. Please try again later.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      }, err => {
        this.util.stopLoader();
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Failed to send invitation. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        });
      });
    } else if (this.inputData == "BUSINESS") {
      data.businessId = localStorage.getItem('businessId');
      
      this.util.startLoader();
      this.auth.create('business/visitor/send/request', data).subscribe(res => {
        this.util.stopLoader();
        
        if (res.code == '00000') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Invite sent successfully',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            // Remove the invited user from the list
            for (let i = 0; i < this.visitorsData.length; i++) {
              if (this.visitorsData[i].userId === user.userId) {
                this.visitorsData.splice(i, 1);
                break;
              }
            }
            
            if (this.visitorsData.length === 0) {
              this.showUI = false;
              this.hide(true);
            }
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Oops..',
            text: 'Something went wrong. Please try again later.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      }, err => {
        this.util.stopLoader();
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error',
          text: 'Failed to send invitation. Please try again later.',
          showConfirmButton: false,
          timer: 3000
        });
      });
    }
  }

  hide(flag) {
    console.log('VisitorsComponent hide: Calling hide with flag =', flag);
    this.commonDatahide.widgetName = "VisitorsComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      console.log('VisitorsComponent hide: Calling commonFunction callback');
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      console.log('VisitorsComponent hide: Emitting via EventEmitter');
      this.commonFunction.emit(this.commonDatahide);
    } else {
      console.log('VisitorsComponent hide: No commonFunction available to call');
    }
  }
}